export const ACCOUNT_PALETTE = [
  "#FF9100", // ブランドオレンジ
  "#3b82f6", // blue-500
  "#10b981", // emerald-500
  "#8b5cf6", // violet-500
  "#06b6d4", // cyan-500
  "#F5C11C", // イエロー
  "#ef4444", // red-500
  "#ec4899", // pink-500
  "#f97316", // orange-500
  "#84cc16", // lime-500
  "#14b8a6", // teal-500
  "#6366f1", // indigo-500
  "#d946ef", // fuchsia-500
  "#22c55e", // green-500
  "#0ea5e9", // sky-500
  "#f43f5e", // rose-500
  "#a855f7", // purple-500
  "#2dd4bf", // teal-400
  "#fb923c", // orange-400
  "#e879f9", // fuchsia-400
]

export const getAccountColor = (accountId: number, allAccounts: { id: number }[]): string => {
  const idx = allAccounts.findIndex(a => a.id === accountId)
  return ACCOUNT_PALETTE[(idx >= 0 ? idx : 0) % ACCOUNT_PALETTE.length]
}
